import axios from 'axios';
import { keccak256, concat, getBytes, hexlify } from 'ethers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/binding`;

export const fetchDemoConfig = () => axios.get(`${API}/demo-config`).then((r) => r.data);
export const submitReceipt = (message, signature) => axios.post(`${API}/receipts`, { message, signature }).then((r) => r.data);
export const runGate = (receiptId, documentText) => axios.post(`${API}/gate`, { receipt_id: receiptId, document_text: documentText }).then((r) => r.data);
export const fetchReceipts = (kypaId, limit = 8) => axios.get(`${API}/receipts`, { params: { kypa_id: kypaId, limit } }).then((r) => r.data);
export const fetchReceiptStats = (kypaId) => axios.get(`${API}/stats/${encodeURIComponent(kypaId)}`).then((r) => r.data);

export function buildMessage(cfg, principal) {
  const now = Math.floor(Date.now() / 1000);
  const rand = crypto.getRandomValues(new Uint32Array(2));
  const nonce = ((BigInt(rand[0]) << 32n) | BigInt(rand[1])).toString();
  return {
    principal,
    kypaId: cfg.kypa_id,
    documentHash: cfg.document_hash,
    actionClass: cfg.action_class,
    counterparty: cfg.counterparty,
    notBefore: now - 30,
    expiry: now + 3600,
    nonce,
    notice: cfg.notice,
  };
}

export function toWalletMessage(m) {
  return { ...m, notBefore: BigInt(m.notBefore), expiry: BigInt(m.expiry), nonce: BigInt(m.nonce) };
}

export const shortHex = (h) => (h ? `${h.slice(0, 10)}...${h.slice(-6)}` : '');

export const fetchReceipt = (id) => axios.get(`${API}/receipts/${id}`).then((r) => r.data);
export const fetchPostureConfig = () => axios.get(`${API}/posture-config`).then((r) => r.data);
export const fetchPosture = (kypaId) => axios.get(`${API}/posture/${encodeURIComponent(kypaId)}`).then((r) => r.data);
export const submitPosture = (message, signature) => axios.post(`${API}/posture`, { message, signature }).then((r) => r.data);

export function verifyMerkleProof(receiptId, proof, root) {
  let node = getBytes(keccak256(receiptId.toLowerCase()));
  for (const p of proof) {
    const sib = getBytes(p);
    node = getBytes(keccak256(hexlify(node) < hexlify(sib) ? concat([node, sib]) : concat([sib, node])));
  }
  return hexlify(node) === root.toLowerCase();
}

export function newNonce() {
  const rand = crypto.getRandomValues(new Uint32Array(2));
  return ((BigInt(rand[0]) << 32n) | BigInt(rand[1])).toString();
}

export const shareUrl = (receiptId) => `${process.env.REACT_APP_BACKEND_URL}/api/og/share/receipt/${receiptId}`;

export const fmtDay = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
